import React from "react";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import moment from "moment";
import { getFullName } from "../util/helpers";
import useMatching from "../../hooks/useMatching";
import { getMatchingConflictsColumns } from "./helper";
const { Title } = Typography;

const EmployeeSchedulingTable = (props) => {
  const { startDate, endDate, employee, type, recurrent_event_conflicts } =
    props;
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  const { conflicts: data, conflictsLoading: loading } = useMatching(
    startDate,
    endDate,
    employee,
    scopePrefix,
    type,
    recurrent_event_conflicts
  );
  const name = getFullName(employee?.surename, employee?.first_name);
  const intl = useIntl();
  const columns = getMatchingConflictsColumns(intl, type);

  return (
    <div style={{ maxWidth: "800px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <Title
          level={2}
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "0",
          }}
        >
          {`${intl.formatMessage({
            id: "app.scheduling.schedulingOf",
          })} ${name}`}
        </Title>
        {type !== "plan" && (
          <Title
            level={5}
            style={{
              margin: "0 0 40px 0",
            }}
          >
            {`${intl.formatMessage({
              id: "app.scheduling.date",
            })}: ${moment(startDate).format("DD/MM/YYYY")}`}
          </Title>
        )}

        <div style={{ width: "100%" }}>
          <Table
            bordered
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.id}
            scroll={{ y: window.innerHeight / 2, x: "max-content" }}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeSchedulingTable;
